module.exports = __webpack_public_path__ + "media/leather_3.79c4b9e4.mp3";